var _style, _path, _circle, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoinLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "Ebene_1",
  width: 230.3,
  height: 58.1,
  preserveAspectRatio: "xMinYMid meet",
  viewBox: "0 0 60 60"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#330645}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M85.7 35.1c0-2.2-1.1-4-4.1-4s-4.6 1.8-5.5 2.8v22.2H62.7v-21c0-2.2-1-4-4.1-4-2.9 0-4.5 1.8-5.4 2.8v22.2H39.8V20.2h13.4v4.1c1.6-2 6.1-5 11.9-5 5.1 0 8.7 1.9 10.3 6.3 2.1-3.1 6.8-6.3 12.6-6.3 6.6 0 11.1 3.3 11.1 10.8v26H85.7zm18.3 3c0-10 7.4-18.8 20.2-18.8s20.2 8.8 20.2 18.8S137 57 124.2 57c-12.7 0-20.2-8.9-20.2-18.9m26.7 0c0-3.9-2.3-7-6.5-7-4.1 0-6.4 3-6.4 7s2.3 7.1 6.4 7.1c4.2 0 6.5-3.1 6.5-7.1m18.7-17.9h13.4v35.9h-13.4zm45.2 16c0-3.7-2-5.1-5.2-5.1-3 0-4.6 1.6-5.7 2.8v22.2h-13.4V20.2h13.4v4.1c2.1-2.4 6-5 12.3-5 8.3 0 12 5.1 12 11.3v25.5h-13.4z",
  className: "st1"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30.5,
  cy: 36.5,
  r: 2.7,
  className: "st1"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.8,
  cy: 36.5,
  r: 2.7,
  className: "st1"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.2,
  cy: 36.5,
  r: 2.7,
  className: "st1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.4 30.2c-3.6 0-6.5-2.9-6.5-6.5s2.9-6.5 6.5-6.5h19.9c3.6 0 6.5 2.9 6.5 6.5v6.5z",
  style: {
    fill: "#f39100"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7 13.6c-3.6 0-6.5-2.9-6.5-6.5S20.1.6 23.7.6h7.1c3.6 0 6.5 2.9 6.5 6.5v6.5z",
  style: {
    fill: "#fdc300"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M229.4 49.5c0 4.2-3.3 7.5-7.5 7.5s-7.5-3.3-7.5-7.5 3.3-7.5 7.5-7.5 7.5 3.3 7.5 7.5M215.2 7.2h13.4v30.7h-13.4z",
  className: "st1"
})));
export default SvgMoinLogo;